<template>
  <div>
    <label for="input-name">Name *: </label>
    <b-form-input
      id="input-name"
      v-model="formData.deliveryDetails.name"
      type="text"
      required
      :state="validName"
      aria-aria-describedby="input-name-feedback"
      placeholder="Nachname"/>
    <b-form-invalid-feedback id="input-name-feedback">Mindestens 3 Buchstaben</b-form-invalid-feedback>
    <label for="input-street">Straße und Hausnummer *: </label>
    <b-form-input
      id="input-street"
      v-model="formData.deliveryDetails.street"
      type="text"
      required
      :state="validStreet"
      placeholder="Straße und Hausnummer"/>
    <label for="input-zip">PLZ *: </label>
    <b-form-input
      id="input-zip"
      v-model="formData.deliveryDetails.zip"
      type="number"
      required
      :state="validZip"
      placeholder="Postleitzahl"/>
    <label for="input-city">Ort *: </label>
    <b-form-input
      id="input-city"
      v-model="formData.deliveryDetails.city"
      type="text"
      required
      :state="validCity"
      placeholder="Ort"/>
    <label for="input-email">eMail *: </label>
    <b-form-input
      id="input-email"
      v-model="formData.deliveryDetails.email"
      type="email"
      required
      :state="validEmail"
      placeholder="eMail"/>
    <b-form-checkbox
      id="input-agb"
      v-model="formData.deliveryDetails.agb"
      name="agb"
      required
      :state="validAgb">
      Ich erkläre mich mit den <a href="/legal/agb">AGB</a> einverstanden
    </b-form-checkbox>
    <b-form-checkbox
      v-if="age18Reqrd"
      id="input-age18"
      v-model="formData.deliveryDetails.age18"
      name="age18"
      required
      :state="validAge18">
      Ich bin über 18 Jahre alt
    </b-form-checkbox>
    <label for="textarea-notice">Anmerkungen: </label>
    <b-form-textarea
      id="textarea-notice"
      v-model="formData.deliveryDetails.notice"
      type="text"
      rows="2"
      max-rows="4"
      no-resize
      placeholder="Anmerkungen"/>
  </div>
</template>

<script>
export default {
  name: 'delivery-details',
  version: '0.0.1',
  props: {
    age18Reqrd: {
      type: Boolean,
      default: false
    }
  }, // props
  components: {}, // components
  data () {
    return {
      loaded: false,
      info: '... loading content!',
      infoStyle: { 'text-align': 'left', color: 'black' },
      // formData: {}
      formData: {
        deliveryDetails: {
          name: null,
          street: null,
          zip: null,
          city: null,
          email: null,
          agb: false,
          age18: false,
          notife: ''
        }
      }
    }
  }, // data
  /* ----- vuejs hooks ----- */
  mounted () {}, // mounted
  computed: {
    validName: function () {
      return (this.formData.deliveryDetails.name && this.formData.deliveryDetails.name.length > 3) ? true : false
    }, // validName
    validStreet: function () {
      return (this.formData.deliveryDetails.street && this.formData.deliveryDetails.street.length > 3) ? true : false
    }, // validStreet
    validZip: function () {
      return (this.formData.deliveryDetails.zip && this.formData.deliveryDetails.zip.length === 5) ? true : false
    }, // validZip
    validCity: function () {
      return (this.formData.deliveryDetails.city && this.formData.deliveryDetails.city.length > 3) ? true : false
    }, // validCity
    validEmail: function () {
      // TODO: extend the validation with @ char
      return (this.formData.deliveryDetails.email && this.formData.deliveryDetails.email.length > 3) ? true : false
    }, // validEmail
    validAgb: function () {
      return this.formData.deliveryDetails.agb
    }, // validAgb
    validAge18: function () {
      return this.formData.deliveryDetails.age18
    }, // validAge18
    validFormData: function () {
      return !(!this.validName || !this.validStreet ||
        !this.validZip || !this.validCity ||
        !this.validEmail || !this.validAgb ||
        (this.age18Reqrd && !this.validAge18))
    }
  }, // computed
  watch: {}, // watch
  methods: {} // methods
}
</script>

<style lang="scss" scoped>
</style>
